export interface Point {
    x: number
    y: number
}
export interface Line {
    start: Point
    end: Point
}

export function tooltipPositioner(
    line: Line,
    tooltip: { width: number; height: number },
    chartPlotbox: { x: number; y: number; width: number; height: number },
    isVertical: boolean,
    expandedWidth: number
): { translateX: number; translateY: number; flip: boolean } {
    let x: number
    let y: number
    let flip = false

    if (isVertical) {
        // Desired tooltip position is: (LEFT, TOP)
        //
        // A marker is:
        //             (top of marker)
        //                    ^
        //                    ^
        // (left side) << ---------- >> (right side)
        //                    v
        //                    v
        //            (bottom of marker)
        //

        // put on the left
        x = line.start.x + 2

        // put on top
        y = line.start.y - tooltip.height - 2

        // Can't put on (LEFT, TOP), put on (LEFT, BOTTOM) instead
        if (y <= chartPlotbox.y) {
            y = line.start.y + 2
            flip = true
        }
    } else {
        // Desired tooltip position is: (RIGHT, TOP)
        //
        // A marker is:
        //           (top of marker)
        //                 ^
        //                 |
        // (left side) <-- | --> (right side)
        //                 |
        //                 v
        //         (bottom of marker)
        //

        // put tooltip on the right side of ther marker
        x = line.start.x + 2
        // put tooltip on the top the marker
        y = line.start.y + 2

        // If cant put on (RIGHT, TOP) put on (LEFT, TOP)
        if (x + expandedWidth >= chartPlotbox.x + chartPlotbox.width) {
            x = x - tooltip.width - 4
            flip = true
        }
    }

    return { translateY: y, translateX: x, flip }
}

export function formPositioner(
    line: Line,
    form: { width: number; height: number },
    chartPlotbox: { x: number; y: number; width: number; height: number },
    isVertical: boolean
): { left: number; top: number } {
    let x: number
    let y: number

    if (isVertical) {
        // Desired form position is: (RIGHT, BOTTOM)
        //
        // A marker is:
        //             (top of marker)
        //                    ^
        //                    ^
        // (left side) << ---------- >> (right side)
        //                    v
        //                    v
        //            (bottom of marker)
        //

        // put on the right
        x = line.end.x - form.width - 4

        // put on bottom
        y = line.end.y + 2

        // Can't put on (RIGHT, BOTTOM), put on (RIGHT, TOP) instead
        if (y + form.height >= chartPlotbox.height) {
            y = line.end.y - form.height - 2
        }
    } else {
        // Desired form position is: (LEFT, BOTTOM)
        //
        // A marker is:
        //           (top of marker)
        //                 ^
        //                 |
        // (left side) <-- | --> (right side)
        //                 |
        //                 v
        //         (bottom of marker)
        //

        // put form on the left
        x = line.end.x - form.width - 4
        // put form on bottom
        y = line.end.y - form.height - 4

        // If cant put on (LEFT, BOTTOM) put on (RIGHT, BOTTOM)
        if (x <= chartPlotbox.x) {
            x = line.end.x + 4
        }
    }

    return { top: y, left: x }
}
